import { useLang } from "@/i18n/LangContext";

export default function LanguageSwitcher({ testId = "language-switcher" }) {
  const { lang, setLang } = useLang();
  const isEN = lang === "en";

  return (
    <div
      data-testid={testId}
      role="group"
      aria-label="Language switcher"
      className="relative inline-flex items-center bg-white/70 backdrop-blur-md border border-black/10 rounded-full p-1 shadow-[0_4px_20px_rgba(0,0,0,0.04)]"
    >
      {/* Sliding indicator */}
      <span
        aria-hidden
        className={`absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full bg-[#1D1D1F] transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
          isEN ? "translate-x-[100%]" : "translate-x-0"
        }`}
        style={{ left: "4px" }}
      />
      <button
        data-testid={`${testId}-hu`}
        type="button"
        onClick={() => setLang("hu")}
        aria-pressed={!isEN}
        className={`relative z-10 px-3.5 md:px-4 py-1.5 text-[11px] md:text-xs font-body font-semibold tracking-[0.18em] uppercase rounded-full transition-colors duration-300 ${
          !isEN ? "text-white" : "text-[#1D1D1F]/70 hover:text-[#1D1D1F]"
        }`}
      >
        HU
      </button>
      <button
        data-testid={`${testId}-en`}
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={isEN}
        className={`relative z-10 px-3.5 md:px-4 py-1.5 text-[11px] md:text-xs font-body font-semibold tracking-[0.18em] uppercase rounded-full transition-colors duration-300 ${
          isEN ? "text-white" : "text-[#1D1D1F]/70 hover:text-[#1D1D1F]"
        }`}
      >
        EN
      </button>
    </div>
  );
}
